export type ImageParams = Record<string, string | number | undefined>;

/** VEX's own `?v=<publish epoch>` and the path must survive untouched. */
export const withImageParams = (imageUrl: string, params: ImageParams): string => {
  const entries = Object.entries(params).filter(
    (entry): entry is [string, string | number] => entry[1] !== undefined
  );

  if (!imageUrl || entries.length === 0) return imageUrl;

  const fragmentIndex = imageUrl.indexOf('#');
  const fragment = fragmentIndex === -1 ? '' : imageUrl.slice(fragmentIndex);
  const url = fragmentIndex === -1 ? imageUrl : imageUrl.slice(0, fragmentIndex);
  const queryIndex = url.indexOf('?');
  const path = queryIndex === -1 ? url : url.slice(0, queryIndex);
  const existing =
    queryIndex === -1
      ? []
      : url
          .slice(queryIndex + 1)
          .split('&')
          .filter(Boolean);

  const replaced = new Set<string>();
  const parameters: string[] = [];

  for (const parameter of existing) {
    const equalsIndex = parameter.indexOf('=');
    const name = equalsIndex === -1 ? parameter : parameter.slice(0, equalsIndex);
    const match = entries.find(([key]) => key === name);

    if (!match) {
      parameters.push(parameter);
    } else if (!replaced.has(name)) {
      replaced.add(name);
      parameters.push(`${name}=${match[1]}`);
    }
  }

  for (const [name, value] of entries) {
    if (!replaced.has(name)) parameters.push(`${name}=${value}`);
  }

  return `${path}?${parameters.join('&')}${fragment}`;
};
